<template lang="html">
  <div class="full-width">
    <v-divider class="pt-0 pb-9" />
    <slot>
      Oops, this page doesn't seem to exist!
    </slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.full-width {
  width: 100%;
  position: absolute;
  left: 0;
  text-align: center;
}
</style>
